export enum PetType {
  DOG = "dog",
  CAT = "cat",
  OTHER = "other",
}
